"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegendItemsLabelsSelector = void 0;
var getLegendItemsLabelsSelector = function (state) { var _a, _b; return (_b = (_a = state.internalChartState) === null || _a === void 0 ? void 0 : _a.getLegendItemsLabels(state)) !== null && _b !== void 0 ? _b : []; };
exports.getLegendItemsLabelsSelector = getLegendItemsLabelsSelector;
//# sourceMappingURL=get_legend_items_labels.js.map